<template>
    <div
        class="row p-4"
    >

        <div class="col-12 col-md-6">
            <h4><b>Total de encuestas:</b> {{ declaration.total }}</h4>
            <apexchart type="bar" height="350" :options="chartOptions" :series="declaration.grafico.series"></apexchart>
        </div>
        <div
            class="col-12 col-md-3"
            v-for="(item,index) in declaration.indicadores"
            :key="index"
        >
            <ListaIndicadores
                :declaration="item"
            />
        </div>


    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import ListaIndicadores from "./generic/ListaIndicadores.vue";
export default {
    name:'EncuestasTab',
    props:{
        declaration: Object,
    },
    components: {
        ListaIndicadores,
        apexcharts: VueApexCharts,
    },
    data(){
        return{

            chartOptions: {
                chart: {
                    type: 'bar',
                    height: 350,
                    toolbar: {
                        show: false,
                        download: false,
                    },
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '65%',
                        endingShape: 'rounded'
                    },
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return val + "%";
                    },
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                xaxis: {
                    categories: ['Buena', 'Regular', 'Mala', 'Sin Respuesta'],
                },
                yaxis: {
                    min: 0,
                    max: 100,
                    title: {
                        text: '% Encuestas'
                    }
                },

                fill: {
                    opacity: 1
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return "% " + val
                        }
                    }
                }
            },


        }
    },
    methods:{

    }
}
</script>
